// O que chega pelo WebSocket do console serial: saída da VM ou aviso do backend.
//
// `CONSOLE_ERROR:` (#1078) é a recusa ao abrir o serial — o agent não conseguiu abrir o
// socket da VM — e `AUTH_ERROR:` a recusa de autenticação. Os dois são DEFINITIVOS: o
// componente para de reconectar (em vez de tentar de novo contra a mesma recusa), escreve
// o motivo no terminal — o console do Cloud Gateway não passa `onError` — e o entrega ao
// `onError` quando houver.
export type MensagemDoSerial =
  | { tipo: 'dados'; texto: string }
  | { tipo: 'erro'; mensagem: string }
  | { tipo: 'ocioso' }

const PREFIXOS_DE_ERRO = ['CONSOLE_ERROR:', 'AUTH_ERROR:']

// Os marcadores vêm no MESMO canal da saída da VM, então só valem ANTES da primeira saída
// dela: a recusa ao abrir chega antes de qualquer byte do guest, e depois disso um guest
// que imprime `CONSOLE_ERROR: x` (um `echo`, um log de boot) é dado, não recusa.
export function classificarMensagemDoSerial(
  texto: string,
  { vmJaFalou = false }: { vmJaFalou?: boolean } = {},
): MensagemDoSerial {
  if (texto === 'Session closed: idle timeout') return { tipo: 'ocioso' }
  if (vmJaFalou) return { tipo: 'dados', texto }
  for (const prefixo of PREFIXOS_DE_ERRO) {
    if (texto.startsWith(prefixo)) {
      return { tipo: 'erro', mensagem: texto.slice(prefixo.length).trim() }
    }
  }
  return { tipo: 'dados', texto }
}
